module.exports = __webpack_public_path__ + "img/arousalEmotionWheel.3874203e.png";